module.exports = __webpack_public_path__ + "static/img/ahib-researchportal-cover.cfed75d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recent-works/ahib-researchportal-cover.png
// module id = rxNR
// module chunks = 1